import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';
import type { TView } from '@alfa-bank/site-text-v2/src/models';

export const configDesktop = {
    titleImg: {
        width: 64,
        height: 64,
    },

    titleView: 'small' as TView,
    subTitleView: 'primary-medium' as TView,
    backgroundOffset: {
        padding: 24,
    } as IStyler,
    titleMargin: {
        marginBottom: 4,
    } as IStyler,
};

export const configMobile = {
    titleImg: {
        width: 64,
        height: 64,
    },
    titleView: 'xsmall' as TView,
    subTitleView: 'primary-small' as TView,
    backgroundOffset: { padding: 16 } as IStyler,
    titleMargin: {
        marginBottom: 8,
    } as IStyler,
};

export const CASHBACK_RESPONSE_MOCKED = [
    {
        groupType: 2032,
        month: '2024-03-01',
        requiredCount: 5,
        categories: [
            {
                id: 16,
                name: 'Фастфуд',
                percentRate: 2.5,
                displayPriority: 1,
                isSelected: false,
                isEditable: true,
                imageLink:
                    // eslint-disable-next-line sonarjs/no-duplicate-string
                    'https://alfabank.servicecdn.ru/site-upload/cd/b2/5725/D_MainB_564x450_310523.png',
            },
            {
                id: 8,
                name: 'Развлечения',
                percentRate: 5,
                displayPriority: 2,
                isSelected: false,
                isEditable: true,
                imageLink:
                    'https://alfabank.servicecdn.ru/site-upload/cd/b2/5725/D_MainB_564x450_310523.png',
            },
            {
                id: 23,
                name: 'АЗС',
                percentRate: 4,
                displayPriority: 3,
                isSelected: false,
                isEditable: true,
                imageLink:
                    'https://alfabank.servicecdn.ru/site-upload/cd/b2/5725/D_MainB_564x450_310523.png',
            },
            {
                id: 51,
                name: 'Кэшбэк не на всё',
                percentRate: 1,
                displayPriority: 4,
                isSelected: true,
                isEditable: true,
                imageLink:
                    'https://alfabank.servicecdn.ru/site-upload/cd/b2/5725/D_MainB_564x450_310523.png',
            },
            {
                id: 59,
                name: 'Кэшбэк на это',
                percentRate: 1,
                displayPriority: 4,
                isSelected: true,
                isEditable: true,
                imageLink:
                    'https://alfabank.servicecdn.ru/site-upload/cd/b2/5725/D_MainB_564x450_310523.png',
            },
            {
                id: 60,
                name: 'Кэшбэк на то',
                percentRate: 1,
                displayPriority: 4,
                isSelected: true,
                isEditable: true,
                imageLink:
                    'https://alfabank.servicecdn.ru/site-upload/cd/b2/5725/D_MainB_564x450_310523.png',
            },
            {
                id: 99,
                name: 'Кэшбэк на всё',
                percentRate: 1,
                displayPriority: 4,
                isSelected: true,
                isEditable: true,
                imageLink:
                    'https://alfabank.servicecdn.ru/site-upload/cd/b2/5725/D_MainB_564x450_310523.png',
            },
        ],
    },
];
